module.exports = __webpack_public_path__ + "img/marmaid_stained_glass.7e8c407b.jpg";